export default __webpack_public_path__ + "static/media/bbcimage15.0d0aaf40.png";